import React from 'react';
import TopMenu from "./Components/TopMenu";
import landing from "./Styles/LandingPage.module.css";

const About = () => {
    return (
        <div className={landing.landing}>
            <TopMenu about={true}/>
            <div style={{
                color:"white",
                display:"flex",
                justifyContent:"center",
                marginTop:"300px",
                fontSize:"3rem"
            }}>Coming soon</div>
        </div>
    );
};

export default About;